<template>
    <b-container>
        <b-modal
            v-model="openRegisterModal"
            size="xl"
            header-bg-variant="dark"
            header-text-variant="light"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            >
            
            <template v-slot:modal-title>
                <div class="pb-2">{{item.nombre}}</div>
            </template>
            <b-row class="my-1 justify-content-md-center">
                <b-col sm="3">
                    <b-img :src="item.imagen" width="200" height="200" fluid alt="Fluid image"></b-img>
                </b-col>
                <b-col sm="5">
                    <div class="pb-2">
                        <label for="input-live"><strong>Código:</strong></label>
                        <b-form-input v-model="item.codigo" placeholder="Referencia" readonly></b-form-input>
                    </div>
                    <div>
                        <label for="input-live"><strong>Existencia total disponible:</strong></label> 
                        <span class="pl-1"><b>{{numberFormat(item.quantities)}}</b></span> 
                    </div>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
                <b-button variant="danger" @click.prevent="$emit('close-modal')">
                    Cancelar
                </b-button>
                <b-button variant="success" @click.prevent="addPriceItem(item)">
                    Agregar
                </b-button>
            </template>
        </b-modal>
    </b-container>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    props: {
        item: {
            type: Object
        },
        openRegisterModal: {
            type: Boolean
        },
        item_type: {
            type: String
        }
    },
    methods:{
        ...mapMutations(['setLoading']),
        async addPriceItem(data){
            this.setLoading(true)
            let item_reference = data.codigo;
            let item_type = this.item_type;
            let dataRequest   = {item_reference, item_type}
            await this.$conectar.post('/admin/recommended-items/store-item', dataRequest)
            .then(response =>{
                if (response.data.error == false) { 
                    this.$emit('close-add-modal');
                    this.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                }else{
                    this.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(error => {
                this.$bvToast.toast("Parece que hubo un error en el servidor", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                console.log(error);
            })
            this.setLoading(false)
        },
        
    }
}
</script>